import * as React from "react";
import { LegendEntryComponent } from "../../components/ui/legendEntryComponent";
import { transformToDefaultValues, useDynamicLegend } from "./legend";
export const DetailedSeriesLegendEntryContainer = ({ chartDivId, detailedItems, visible, time, onToggle, }) => {
    const legendEntry = detailedItems[0].legendEntry;
    const [detailedSeriesKey, detailedSeriesName] = legendEntry.name.split("_");
    const defaultValues = transformToDefaultValues(detailedItems, time);
    const entry = useDynamicLegend(chartDivId, defaultValues, (values) => values.key.startsWith(detailedSeriesKey) && values.yValue === 1, (values) => {
        var _a, _b;
        return (_b = (_a = detailedItems.find((item) => item.key === values.key)) === null || _a === void 0 ? void 0 : _a.flag) === null || _b === void 0 ? void 0 : _b.unitSubstitution;
    });
    return (React.createElement(LegendEntryComponent, Object.assign({}, entry, { color: "", unit: "", name: detailedSeriesName, mode: "optional", visible: visible, onToggle: onToggle })));
};
//# sourceMappingURL=DetailedSeriesLegendEntryContainer.js.map